import { render, staticRenderFns } from "./ActivityNotification.vue?vue&type=template&id=6c277556&scoped=true&"
import script from "./ActivityNotification.vue?vue&type=script&lang=js&"
export * from "./ActivityNotification.vue?vue&type=script&lang=js&"
import style0 from "./ActivityNotification.vue?vue&type=style&index=0&id=6c277556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c277556",
  null
  
)

export default component.exports